import './styles/info-alert-bar.scss';
import React, {PropTypes} from 'react';
import AlertBarBase from './alert-bar-base';

export const InfoAlertBar = props =>
    <div className='info-alert-bar'>
        <AlertBarBase
            alertTitle={props.alertTitle}
            dismissHandler={props.dismissHandler}
            iconClass='icon-info-white'
            isDismissable={props.isDismissable}
            timeoutLength={props.timeoutLength}
            willAutoDismiss={props.willAutoDismiss}
        >
            {props.children}
        </AlertBarBase>
    </div>;

InfoAlertBar.displayName = 'InfoAlertBar';

InfoAlertBar.propTypes = {
    alertTitle: PropTypes.any.isRequired,
    children: PropTypes.any.isRequired,
    dismissHandler: PropTypes.func.isRequired,
    isDismissable: PropTypes.bool,
    timeoutLength: PropTypes.number,
    willAutoDismiss: PropTypes.bool
};

InfoAlertBar.defaultProps = {
    isDismissable: true,
    willAutoDismiss: false
};

export default InfoAlertBar;



// WEBPACK FOOTER //
// ./src/shared/components/alert-bar/info-alert-bar.js